import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import { AbstractDialogPlayerMediator } from "../../../ngt/dialog/view/AbstractDialogPlayerMediators";
import TextContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/TextContent";
import ImageContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/ImageContent";
import AssetLibrary from "../../../core/assetloading/AssetLibrary";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";

export default class DecisionScreenMediator extends AbstractDialogPlayerMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {AssetLibrary} assetLibrary 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, assetLibrary, languagePack) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._assetLibrary = assetLibrary;
        this._languagePack = languagePack;
    }

    initialize() {
        super.initialize();

        this._dilemmaTextField = this._target.dilemmaTextField;
        this._dilemmaTextField.text = "";

        this._imageContainer = this._target.imageContainer;

        this._initializeOptionButtons();

        this._continueButton = this.createButton(this._target.continueButton, this._handleContinueButton.bind(this), this._languagePack.getText('decision.continueButtonLabel'));
        this._continueButton.setEnabled(false);

        const dialogPlayer = this.getCustomData().dialogPlayer;
        this.setDialogPlayer(dialogPlayer);

        this.stretchBackground();
        this.preventClickThrough();
    }

    _initializeOptionButtons() {
        if (this._optionButtons) {
            console.warn(`Option buttons are already initialized. Skipping initialization...`);
            return;
        }

        this._optionButtons = [];

        let optionButtonSkin;
        for (let i = 1; optionButtonSkin = this._target[`option${i}`]; i++) {
            const optionButton = this.createButton(optionButtonSkin, this._handleOptionButton.bind(this));
            optionButton.setVisible(false);
            this._optionButtons.push(optionButton);
        }
    }

    _handleOptionButton(evt) {
        const optionButton = evt.target;
        this._selectOptionButton(optionButton);
    }

    _handleCommandSequenceEnd(evt) {
        const currentOptions = this.getDialogPlayer().getCurrentOptions();
        for (let i = 0; i < Math.min(this._optionButtons.length, currentOptions.length); i++) {
            const optionButton = this._optionButtons[i];

            const option = currentOptions[i];
            optionButton.option = option;

            const dialogContentPackage = option.getData().getData();
            const content = dialogContentPackage.content;
            optionButton.setLabel(content.getText());
            optionButton.setVisible(true);
        }

        for (let i = Math.min(this._optionButtons.length, currentOptions.length); i < this._optionButtons.length; i++) {
            const optionButton = this._optionButtons[i];
            optionButton.option = null;

            optionButton.setVisible(false);
        }
    }

    /**
     * @param {TextContent} content 
     */
    _handleTextContent(content) {
        this._dilemmaTextField.text = content.getText();
    }

    /**
     * @param {ImageContent} content 
     */
    _handleImageContent(content) {
        this._imageContainer.removeAllChildren();

        // Retrieve image
        const imageId = content.getImage();
        const image = this._assetLibrary.getAsset(imageId);
        if (!image) {
            console.warn(`Decision image not found!`, imageId);
            return;
        }

        const bitmap = new createjs.Bitmap(image);

        // Center image
        const bitmapBounds = bitmap.getBounds();
        bitmap.regX = bitmapBounds.width * .5;
        bitmap.regY = bitmapBounds.height * .5;

        this._imageContainer.addChild(bitmap);
    }

    _handleDialogOptionChosen() {
        for (let i = 0; i < this._optionButtons.length; i++) {
            const optionButton = this._optionButtons[i];
            optionButton.option = null;

            optionButton.setVisible(false);
        }
    }

    _selectOptionButton(targetOptionButton) {
        for (let i = 0; i < this._optionButtons.length; i++) {
            const optionButton = this._optionButtons[i];
            optionButton.setSelected(false);
        }

        targetOptionButton.setSelected(true);
        this._continueButton.setEnabled(true);

        this._selectedOption = targetOptionButton.option;
    }

    _handleContinueButton() {
        if (this._continueButtonPressed) {
            return;
        }
        this._continueButtonPressed = true;

        this.getDialogPlayer().optionChosen(this._selectedOption);
    }
}